<template>
	<page class="question" id="top" @scrollChange="scrollChange" v-if="$route.path === '/visitor/question'">
		<zui-header></zui-header>
		<PageNavigater></PageNavigater>
		<div class="contain">
			<div class="top-img"></div>
			<div class="content">
				<div class="question-title">
					<div class="question-header">问题汇总</div>
					<div class="flexWarp">
						<div class="flexWarp-item" @click="toId(item.id)" v-for="item in list" :key="item.id">
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="collapse">
					<el-collapse v-model="activeName" accordion>
						<el-collapse-item :name="item.id" :id="item.id" v-for="(item,index) in list" :key="item.id">
							<template slot="title">
								{{parseInt(index+1).toString().length>1?parseInt(index+1):'0'+parseInt(index+1)}}.{{item.title}}
								<div class="question-arrow"></div>
							</template>
							<div class="warp" v-html="item.content">
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
			</div>
			<!--<div class="detailButton1" v-if="showButton" @click="back()">
				<span>返回上级</span>
			</div>-->
			<div class="detailButton2" v-if="showButton" @click="toTop()">
				<span>回到顶部</span>
			</div>
		</div>
		<zui-footer />
	</page>
</template>

<script>
	import {
		getArticles
	} from "~/api/CmsApi";
	import '~/views/less/question.css'
	import Page from '~/components/Page'
	import ZuiHeader from '~/components/Header'
	import ZuiFooter from '~/components/Footer'
	export default {
		components: {
			Page,
			ZuiHeader,
			ZuiFooter
		},
		data() {
			return {
				activeName: '1',
				list: [],
				showButton: false,
				isIE: false,
				isUC: false
			};
		},
		created() {
			this.init();
			if (document.documentMode)
				this.isIE = true;
			if (navigator.appVersion.indexOf('UBrowser/'))
				this.isUC = true;
			if ((this.isIE || this.isUC) && !document.body.scrollTo) {
				Element.prototype.scrollTo = function(option) {
					this.scrollLeft = option.left;
					this.scrollTop = option.top;
				};
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				window.addEventListener('scroll', this.onScroll)
			})
		},
		methods: {
			toId(id) {
				document.getElementById(id).scrollIntoView({
					behavior: "smooth",
					block: 'center'
				});
			},
			handleChange(val) {
				console.log(val);
			},
			onScroll() {
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop // 586、1063分别为第二个和第三个锚点对应的距离
				if (scrolled > 600) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			},
			back() {
				this.$router.go(-1)
			},
			toTop() {
				// document.getElementById('top').scrollIntoView({
				// 	behavior: "smooth"
				// });
				if (this.isIE || this.isUC)
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
				else
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({top: 0, behavior: 'smooth'})
			},
			init() {
				getArticles({
					sortBy: 1,
					cateId: 999,
					page: 1,
					limit: 999
				}).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						console.log(list)
						this.list = list
					} else {
						console.warn('文章信息获取失败');
					}
				})
			},
			scrollChange(height) {
				if (height > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/visitor/question.vue